import { render, staticRenderFns } from "./FormPicContent.vue?vue&type=template&id=96361716&scoped=true&"
import script from "./FormPicContent.vue?vue&type=script&lang=js&"
export * from "./FormPicContent.vue?vue&type=script&lang=js&"
import style0 from "./FormPicContent.vue?vue&type=style&index=0&id=96361716&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96361716",
  null
  
)

export default component.exports